import {ActivatedRouteSnapshot, CanActivate, NavigationEnd, Router, RouterStateSnapshot} from "@angular/router";

import {HttpCommonService} from "../services/http-common.service";
import {NzMessageService} from "ng-zorro-antd";
import {Injectable} from "@angular/core";
import {GlobalService} from "../services/global.service";

/**
 *  404页面路由守卫
 */
@Injectable()
export class BadGuard implements CanActivate {

  constructor(private msg: NzMessageService, public http: HttpCommonService,
              private globalService: GlobalService, private router: Router){}

  canActivate(routerInfo: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let userId = routerInfo.queryParams['userId'];
    let userName = routerInfo.queryParams['userName']
    this.router.navigate(["/gzEcommerceSearch"],
      {queryParams: {userId: userId, userName: userName}});

    return false ;
  }


}



// WEBPACK FOOTER //
// E:/java/gd-project/credit-gd-web/src/app/guard/BadGuard.ts